module.exports = __webpack_public_path__ + "img/5.9fb4bd2c.jpg";